const $ = jQuery.noConflict()

var self = module.exports = {
  duration: 1000,

  delimiter: wNumb({
    decimals: 0,
    mark: '.',
    thousand: ','
  }),

  init: function(trigger) {
    self.events.scroll(trigger)
  },

  events: {
    scroll: function(trigger) {
      $(window).on('scroll', function () {
        $(trigger).each(function() {
          self.service.check(this)
        })
      })
    }
  },

  service: {
    count: function(target, start, end) {
      var range = end - start
      var increment = self.service.secure(range)
      var stepTime = range <= 1000 ? Math.ceil(self.duration / range) : 10
      var current = start

      var timer = setInterval(function() {
        current += increment
        $(target).html(self.service.delimit(current))

        if (current >= end) {
          clearInterval(timer)
          $(target).html(self.service.delimit(end))
        }
      }, stepTime)
    },

    secure: function(number) {
      if (number > 1000) {
        number = number / 100
      } else {
        number = 1
      }

      return number
    },

    delimit: function(number) {
      number = self.delimiter.to(number)
      return number
    },

    concat: function(number) {
      if (typeof number === 'string') {
        number = self.delimiter.from(number)
      }

      return number
    },

    check: function(trigger) {
      if ($(trigger).hasClass('arrived') && !$(trigger).hasClass('counted')) {
        var start = 0
        var end = self.service.concat($(trigger).data('stat'))

        self.service.count(trigger, start, end)
        $(trigger).addClass('counted')
      }
    }
  }
}
